"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWatch = void 0;
class IWatch {
}
exports.IWatch = IWatch;
